export default __webpack_public_path__ + "static/media/home2.a65a4256.png";